import { AssetProperties } from '../../asset/types/asset.type';
import { CompanyProperties } from '../../company/types/company.type';
import { DeviceProperties } from '../../device/types/device.type';
import { GroupProperties } from '../../group/types/group.type';

export type OperationModeProperties = {
  operationModeId: string;
  groupId: string;
  companyId: string;
  assetId: string;
  deviceId: string;
  status: string;
  createdByUserId: string;
  userCreator?: {
    name?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
  };
  startAt: Date;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  group?: GroupProperties;
  company?: CompanyProperties;
  asset?: AssetProperties;
  device?: DeviceProperties;
  operationModeDetails?: OperationModeDetailProperties[];
  isRamus2?: boolean;
  cloneData?: {
    assetId: string
    name: string
    company: {
      companyId: string
      name: string
    }
  }
};

export const initialOperationMode: OperationModeProperties = {
  operationModeId: '',
  groupId: '',
  companyId: '',
  assetId: '',
  deviceId: '',
  status: '',
  createdByUserId: '',
  startAt: new Date(),
};

export interface ICreateOperationMode {
  groupId: string;
  companyId: string;
  assetId: string;
  deviceId: string;
  status: string;
  startAt: Date;
}

// operation mode detail
export type OperationModeDetailProperties = {
  operationModeDetailId: string;
  operationModeId: string;
  name: string;
  rpmMin?: string | null;
  rpmMax?: string | null;
  clutchMax?: string | null;
  consumptionRate: string;
  speed?: string | null;
  speedOperator?: string | null;
  status: string;
  createdByUserId: string;
  userCreatorName: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
  devices?: DeviceProperties[];
  isRamus2?: boolean;
};

export type Ramus2OperationModeSpeedConfig = {
  compareOperationModeSpeed: boolean;
  speedMaxByOperationModeDetailId: Record<string, string>;
};

export const initialOperationModeDetail: OperationModeDetailProperties = {
  operationModeDetailId: '',
  operationModeId: '',
  name: '',
  rpmMin: null,
  rpmMax: '',
  clutchMax: null,
  consumptionRate: '',
  speed: null,
  speedOperator: null,
  status: '',
  createdByUserId: '',
  userCreatorName: '',
  createdAt: new Date(),
  updatedAt: new Date(),
};

export interface ICreateOperationModeDetail {
  operationModeId: string;
  name: string;
  rpmMin?: string | null;
  rpmMax?: string | null;
  clutchMax?: string | null;
  consumptionRate: string;
  speed?: string | null;
  speedOperator?: string | null;
  status: string;
  createdByUserId: string;
}

export const SPEED_OPERATORS = ['<', '<=', '>', '>='] as const;

export function isClutchOperationModeDevice(deviceId?: string | null): boolean {
  return (deviceId || '').toLowerCase().includes('clutch');
}
